import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // If navigation set a specific section to scroll to (handled in Navigation), don't force top
    const hasPendingSectionScroll = !!sessionStorage.getItem("scrollTarget");
    if (hasPendingSectionScroll) return;

    // If URL contains a hash, let section/hash handling take over
    if (location.hash) return;

    // Scroll to top on route/path changes
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname, location.hash]);

  return null;
};

export default ScrollToTop;
